import React from "react";
import { WargamesInProgressQuery } from "../../../graphql";
import { ActiveWargame } from "../../Wargame";
import { usePollingQuery } from "../../../hooks";
import { IsCronosTriggerWargame } from "../../../utils/cronos";
export var ActiveWargameForService = function (_a) {
    var _b, _c;
    var serviceId = _a.serviceId, _d = _a.isVisible, isVisible = _d === void 0 ? true : _d, trigger = _a.trigger;
    var _e = usePollingQuery(WargamesInProgressQuery, {
        variables: { serviceId: serviceId }
    }, isVisible), loading = _e.loading, data = _e.data;
    return (React.createElement(ActiveWargame, { serviceId: serviceId, activeWargames: (_c = (_b = data === null || data === void 0 ? void 0 : data.warGamesInProgressForService) === null || _b === void 0 ? void 0 : _b.filter(function (wargame) {
            return IsCronosTriggerWargame(wargame, trigger);
        })) !== null && _c !== void 0 ? _c : [], isLoading: loading }));
};
